import { AppLayout } from 'layouts';
import { JournalFeed } from 'features/feed';
import { Sidebar } from 'features/sidebar';
import { useFeedbackOptions } from 'pages/hooks';

const PageJournal = () => {
  const feedbackOptions = useFeedbackOptions();

  return (
    <AppLayout aside={<Sidebar feedbackOptions={feedbackOptions} hideTodosFeedCta={false} />}>
      <JournalFeed />
    </AppLayout>
  );
};

export default PageJournal;
